import { NormalizedNumber, Percentage, UnixDuration } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'

export interface CalculateFarmApyParams {
  rewardToken: Token
  rewardRate: NormalizedNumber
  stakingToken: Token
  totalSupply: NormalizedNumber
}

export function calculateFarmApy({
  rewardToken,
  rewardRate,
  stakingToken,
  totalSupply,
}: CalculateFarmApyParams): Percentage {
  if (totalSupply.eq(0)) {
    return Percentage(0)
  }

  return Percentage(
    rewardToken
      .toUSD(rewardRate)
      .div(stakingToken.toUSD(totalSupply))
      .times(Number(UnixDuration({ years: 1 }).toSeconds())),
    { allowMoreThan1: true },
  )
}
